
<template>

    <section class="mentorship-connections">
        <div class="panel" v-if="requests">
            <div class="panel-heading">
                <h2 v-if="isMentor">Mentee Connections Initiated</h2>
                <h2 v-else>Mentor Connections Initiated</h2>
            </div>

            <div class="panel-body">

                <table class="table">
                    <thead>
                        <tr>
                            <th></th>
                            <th>Mentor's Name</th>
                            <th>Mentor's Email</th>
                            <th>#1 Mentor's Approval</th>
                            <th>#2 Student's Choice</th>
                            <th>Status</th>
                        </tr>
                    </thead>

                    <tbody v-if="requests.length > 0">
                        <tr v-for="request in requests">
                            <td v-if="isMentor"><img class="avatar" :src="request.student.avatar"></td>
                            <td v-else><img class="avatar" :src="request.mentor.mentor_profile.avatar"></td>

                            <td v-if="isMentor">{{request.student.firstName}} {{request.student.lastName}}</td>
                            <td v-else>
                                <router-link :to="{name: 'mentorProfile', params:{id: request.mentor.id}}">
                                    {{request.mentor.firstName}} {{request.mentor.lastName}}
                                </router-link>
                            </td>

                            <td v-if="isMentor"><a :href="'mailto:'+request.student.email">{{request.student.email}}</a></td>
                            <td v-else><a :href="'mailto:'+request.mentor.email">{{request.mentor.email}}</a></td>

                            <td>
                                <span class="limbo" v-if="isMentor && request.approvedByMentor === null">
                                    Mentor Approved
                                    <i @click="updateRequest(request.id, true)" class="fa fa-check"></i>
                                    <i @click="updateRequest(request.id, false)" class="fa fa-remove"></i>
                                </span>

                                <span class="limbo disabled" v-if="!isMentor && request.approvedByMentor === null">
                                    Mentor Approved
                                    <i class="fa fa-check"></i>
                                    <i class="fa fa-remove"></i>
                                </span>

                                <span class="approved" v-if="request.approvedByMentor === true">
                                    Mentor Approved
                                    <i class="fa fa-check"></i>
                                    <i class="fa fa-remove inactive"></i>
                                </span>

                                <span class="declined" v-if="request.approvedByMentor === false">
                                    Mentor Approved
                                    <i class="fa fa-check inactive"></i>
                                    <i class="fa fa-remove"></i>
                                </span>

                            </td>

                            <td>

                                <span class="limbo" v-if="!isMentor && request.approvedByStudent === null">
                                    Student Approved
                                    <i @click="updateRequest(request.id, true)" class="fa fa-check"></i>
                                    <i @click="updateRequest(request.id, false)" class="fa fa-remove"></i>
                                </span>

                                <span class="limbo disabled" v-if="isMentor && request.approvedByStudent === null">
                                    Student Approved
                                    <i class="fa fa-check"></i>
                                    <i class="fa fa-remove"></i>
                                </span>

                                <span class="approved" v-if="request.approvedByStudent === true">
                                    Student Approved
                                    <i class="fa fa-check"></i>
                                    <i class="fa fa-remove inactive"></i>
                                </span>

                                <span class="declined" v-if="request.approvedByStudent === false">
                                    Student Approved
                                    <i class="fa fa-check inactive"></i>
                                    <i class="fa fa-remove"></i>
                                </span>

                            </td>


                            <td>{{status(request)}}</td>
                        </tr>
                    </tbody>
                    <tbody v-else>
                    <tr>
                        <td></td>
                        <td colspan="6">No connections made yet</td>
                    </tr></tbody>

                </table>

            </div>

        </div>
    </section>

</template>


<script>

import mentors from '../services/mentors';

import toastr from 'toastr';
import { uniqBy } from 'lodash';

export default {
    data() {
        return {
            requests:null
        }
    },
    mounted() {
        this.getRequests();
    },
    methods: {
        getRequests() {
            var self = this;
            mentors.getRequests(this).then(function(response) {
                self.requests = uniqBy(response.data.requests, (r) => r.id);
            });
        },
        updateRequest(id, change) {
            var self = this;
            mentors.updateRequest(this, id, change).then(function(response) {
                response.data.success === true ? toastr.success('Updated') : toastr.error(response.data.message || 'Error updating');
                self.getRequests();
            });
        },
        status(request) {

            if (!localStorage.roles.includes('Mentor')) {
                if (request.mentor.mentees && request.mentor.mentees.length > 2) {
                    return 'Full'
                }
            }
            if (request.approvedByMentor === true && request.approvedByStudent === true) {
                if (localStorage.roles.includes('Mentor')) {
                    if (request.mentorId == localStorage.user_id) {
                        return 'Mentorship approved';
                    } else {
                        return 'Taken';
                    }
                }
                else {

                    return 'Mentorship Approved';
                }
            }

            if (localStorage.roles.includes('Mentor')) {
                if (request.approvedByMentor === null) {
                    return 'Waiting on you';
                }
                if (request.approvedByStudent === null) {
                    return 'Waiting on them';
                }
            }

            if (!localStorage.roles.includes('Mentor')) {
                if (request.approvedByMentor === null) {
                    return 'Waiting on them';
                }
                if (request.approvedByStudent === null) {
                    return 'Waiting on you';
                }
            }

            return 'Closed';
        }
    },
    computed: {
        isMentor() {
            return localStorage.roles.includes('Mentor');
        }
    }
}
</script>


<style lang="scss" scoped>
    table {
        td {
            text-align:left;
            vertical-align:inherit!important;
        }
        i {
            cursor:pointer;
            font-size:2rem;
        }
        th {
            font-weight:100;
            font-size:1.3em;
            padding: 2.5rem 0!important;
        }
    }
    .disabled {
        color:#595959;
        i {
            pointer-events: none;
        }
    }
    .avatar {
        position:relative;
        top:.1rem;
        left:1rem;
        width:50px;
        height:50px;
        border-radius:50%;
        object-fit:cover;
    }

    .approved {
        color: green;
    }
    .declined {
        color: red;
    }
    .inactive {
        color: grey;
    }

</style>



// WEBPACK FOOTER //
// MentorConnections.vue?0a10caf7